/**
 * `fetch` for direct calls to the IBE backend. Use it for every new backend fetch, so
 * there is one place to change how those calls are sent.
 */
export const backendFetch = (input: RequestInfo | URL, init?: RequestInit): Promise<Response> =>
  fetch(input, init);
